export default class WallModel {
    constructor(
    ) {
        this.color = '#fff'
    }
}